import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const borderDefinition = {
  top: { style: 'thin' },
  left: { style: 'thin' },
  bottom: { style: 'thin' },
  right: { style: 'thin' },
};

export const buildReportExportUrl = (path, params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      value
        .filter((entry) => entry !== null && entry !== undefined && entry !== '')
        .forEach((entry) => query.append(key, String(entry)));
      return;
    }

    query.set(key, String(value));
  });

  const queryString = query.toString();
  return queryString ? `${path}?${queryString}` : path;
};

export const startNativeFileDownload = (exportUrl) => {
  if (!exportUrl) {
    return false;
  }

  window.location.assign(exportUrl);
  return true;
};

export const copyExportUrl = async (exportUrl) => {
  if (!exportUrl || !navigator.clipboard?.writeText) {
    return false;
  }

  await navigator.clipboard.writeText(new URL(exportUrl, window.location.origin).toString());
  return true;
};

const exportExcel = async (title, fileName, sheets, theme) => {
  if (sheets.size === 0) {
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const headerColor = `FF${theme.palette.primary.main.replace('#', '').toUpperCase()}`;

  sheets.forEach((rows, sheetTitle) => {
    const worksheet = workbook.addWorksheet(sheetTitle);
    const headers = Object.keys(rows[0]);

    const titleRow = worksheet.addRow([title]);
    if (headers.length > 1) {
      worksheet.mergeCells(1, 1, 1, headers.length);
    }
    titleRow.font = { bold: true };

    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.border = borderDefinition;
      cell.font = {};
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: headerColor },
      };
    });

    rows.forEach((item) => {
      const values = headers.map((header) => item[header]);
      const row = worksheet.addRow(values);
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = borderDefinition;
        cell.font = {};
      });
    });

    headers.forEach((header, index) => {
      let maxLength = String(header).length;
      rows.forEach((item) => {
        const value = item[header];
        if (value !== null && value !== undefined) {
          const text = typeof value === 'string' ? value : String(value);
          maxLength = Math.max(maxLength, text.length);
        }
      });
      worksheet.getColumn(index + 1).width = Math.max(maxLength + 2, 10);
    });
  });

  const blob = new Blob(
    [await workbook.xlsx.writeBuffer()],
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  );
  saveAs(blob, fileName);
};

export default exportExcel;
